import React, { useEffect, useState, Suspense } from "react";

import { useLocation } from "react-router-dom";
import useUser from "../hooks/useUser";
import useTenant from "../hooks/useTenant";

const InvoiceDetails = () => {
  const { getTenantSettings, tenantSetting } = useTenant();
  const [DynamicComponent, setDynamicComponent] = useState(null);

  const { state } = useLocation();
  const { getRenewal, renewal } = useUser();

  const fetchData = async () => {
    await getRenewal(state.id);
  };
  const fetchTenantSettings = async (tenantId) => {
    await getTenantSettings(tenantId);
  };
  const loadComponent = async (componentName) => {
    console.log(componentName, "componentName");
    try {
      const { default: MyComponent } = await import("./" + componentName);
      setDynamicComponent(() => MyComponent);
    } catch (error) {
      console.error("Error loading the component:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (tenantSetting != null && Object.keys(tenantSetting).length != 0) {
      loadComponent(tenantSetting.invoiceTemplate);
    }
  }, [tenantSetting]);

  useEffect(() => {
    if (Object.keys(renewal).length != 0) {
      fetchTenantSettings(renewal?.msoTenantId);
    }
  }, [renewal]);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        {DynamicComponent ? <DynamicComponent /> : null}
      </Suspense>
    </>
  );
};

export default InvoiceDetails;
